import id from './id.json'
import en from './en.json'

export default {
    id,en
}
